import React from 'react';
import * as H1 from '../Helper/H1';
import Send from '../Helper/Send';
import $ from "jquery";
import { NavLink, useParams, useNavigate } from 'react-router-dom';
import {Button, Message } from 'rsuite';


function withParams(Component) {
  return props => <Component {...props} params={useParams()} navigation={useNavigate()} />;
}




export class Live extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        item_id: this.props.params.id,
        is_live: null,
        live_id: null,
        live_url: null,
        subed: null,

    };
}




   componentDidMount() {


    Send('page/live/' + this.state.item_id, "", true).then((res) => {
      this.setState({
        is_live: res.data.live.is_live,
        live_id: res.data.live.live_id,
        live_url: res.data.live.live_url,
        subed: res.data.subed,
      }, () => {

        if(res.data.subed){

          const script = document.createElement("script");
          script.src = this.state.live_url;
          // script.onload = () => this.scriptLoaded();
          $(`#${this.state.live_id}`).append(script);
        }
   

      }
      
      
      );

   
  }).catch((err) => { });








   }


   componentWillUnmount() {

    this.setState({live_id:null});

}


  

  render() {

    H1.page_name("پخش زنده");

    
  return !this.state.live_id || !this.state.is_live ? null : (

            
<div className="h-100 mt-3 p-3">


              <div className='c-row mb-2'>
                    <div className="text-center mb-2 py-2 position-relative">
                        <span className='fs-6'>پخش زنده</span>
                        <span className="icon-Back float-end fs-3" onClick={() => this.props.navigation(-1)} ></span>
                    </div>
                </div>




                {!this.state.subed &&

                  <Message showIcon type="warning">
                        برای مشاهده پخش زنده باید اشتراک ویژه تهیه فرمایید.

                      <hr/>
                     <NavLink exact="true" to='/cart/sub'> <Button appearance="ghost" color='green' className='fw-light  mx-auto d-block' > خرید اشتراک </Button> </NavLink>

                  </Message>

                  
                }


        {this.state.subed && this.state.live_id &&


            <div className="live_box" >


                <div id={this.state.live_id}>
          


                </div>



              </div>

        }
              </div>
         



    )
  }



}

export default withParams(Live);

